import React from "react";
import "../../styles/UserForm.css";

export default function ViewRole({
  roleData,
  onClose,
  onEdit,
}) {
  if (!roleData) return null;

  return (
    <div className="uf-modal" onClick={onClose}>
      <div
        className="uf-card"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="uf-header">
          <h5 className="text-white">Role Details</h5>
          <button onClick={onClose}>✕</button>
        </div>

        <div className="uf-body">
          <div className="uf-grid">
            <div>
              <label className="form-label">Name</label>
              <input
                className="form-control"
                readOnly
                value={roleData.name || ""}
              />
            </div>
            <div>
              <label className="form-label">Code</label>
              <input
                className="form-control"
                readOnly
                value={roleData.code || ""}
              />
            </div>
            <div>
              <label className="form-label">Description</label>
              <input
                className="form-control"
                readOnly
                value={roleData.description || ""}
              />
            </div>
            <div>
              <label className="form-label">Status</label>
              <span
                className={`badge ${
                  roleData.status === "Active"
                    ? "bg-success"
                    : "bg-secondary"
                }`}
              >
                {roleData.status}
              </span>
            </div>
            <div>
              <label className="form-label">Created</label>
              <input
                className="form-control"
                readOnly
                value={
                  (roleData.created_at || "").split("T")[0]
                }
              />
            </div>
          </div>
        </div>

        <div className="uf-actions">
          <button
            type="button"
            className="btn btn-cancel"
            onClick={onClose}
          >
            Close
          </button>
          <button
            className="btn btn-primary"
            onClick={() => onEdit(roleData)}
          >
            Edit Role
          </button>
        </div>
      </div>
    </div>
  );
}
